import rateLimit from './rate-limit.json';
import validation from './validation.json';

const messages = {
  validation,
  rateLimit,
};

export default messages;
